import { Chip } from '@/global/components/Chip'
import { hasPermission } from '@/hooks/useBackendMenu'
import { TipoCompensacaoManual } from '@acme/core'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import {
    CompensacaoManual,
    compensacaoManual,
} from 'service/api/endpoints/compensacao-manual'
import { toast } from 'sonner'
import FormCompensacaoManual from '../../CompensacaoManual/forms/FormCompensacaoManual'
import {
    useDigitacaoDataContext,
    useUpdateDigitacaoQueryData,
} from '../pages/useDigitacaoData'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export default function DetalhesCompensacaoManual() {
    const { mutateAsync: deleteMutateAsync, isLoading: isDeleting } =
        compensacaoManual.mutations.useDelete()
    const { mutateAsync: updateMutateAsync, isLoading: isUpdating } =
        compensacaoManual.mutations.useUpdate()
    const navigate = useNavigate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { id } = useParams()
    const {
        context: { data },
    } = useDigitacaoDataContext()

    const compensacao = data.find(
        ({ compensacaoManual }) => compensacaoManual?.id === Number(id),
    )?.compensacaoManual

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()

    if (!compensacao) return null

    const handleExcluir = () => {
        deleteMutateAsync(compensacao.id, {
            onSuccess: () => {
                setQueryData('COMPENSACAO_MANUAL', compensacao, true)
                toast.success('Compensação manual excluída com sucesso')
                navigate(-1)
            },
            onError: e => {
                toast.error(e.message)
            },
        })
    }

    const handleSubmit: SubmitHandler<CompensacaoManual> = input => {
        updateMutateAsync(
            {
                ...input,
                competencia: compensacao.competencia,
                id: Number(id),
            },
            {
                onSuccess: res => {
                    setQueryData('COMPENSACAO_MANUAL', res)
                    toast.success('Compensação manual atualizada com sucesso')
                    navigate(-1)
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'CompensaçãoManual'])}
            defaultValues={{
                tipo: compensacao.tipo,
                empresaId: compensacao.empresaId,
                funcionarioId: compensacao.funcionarioId,
                data: compensacao.data,
                destinos: compensacao.Destinos?.map(d => ({
                    data: dayjs.utc(d.data).toDate(),
                })),
            }}
            onDelete={
                hasPermission(['delete', 'CompensaçãoManual']) ||
                funcionarioPodeAjustar
                    ? handleExcluir
                    : undefined
            }
            height="auto"
            onSubmit={
                hasPermission(['update', 'CompensaçãoManual'])
                    ? handleSubmit
                    : undefined
            }
            loading={isDeleting || isUpdating}
        >
            <Dialog.Title>Detalhes da compensação manual</Dialog.Title>
            <Dialog.Content dividers>
                <FormCompensacaoManual />
                <Dialog.Content.Footer>
                    {hasPermission(['delete', 'CompensaçãoManual'])
                        ? ({ toggleDelete }) => (
                              <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                      <div className="flex items-center gap-2 justify-between">
                                          <FormControlLabel
                                              control={<Checkbox />}
                                              onChange={() => {
                                                  toggleDelete?.()
                                              }}
                                              label="Deseja excluir este item?"
                                          />
                                          {compensacao.tipo ===
                                          TipoCompensacaoManual.MESMO_DIA ? null : (
                                              <Chip
                                                  label={
                                                      compensacao.calculoId
                                                          ? 'Processado'
                                                          : 'Não processado'
                                                  }
                                                  color={
                                                      compensacao.calculoId
                                                          ? 'success'
                                                          : undefined
                                                  }
                                              />
                                          )}
                                      </div>
                                  </Grid>
                              </Grid>
                          )
                        : null}
                </Dialog.Content.Footer>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
